import { gql, DocumentNode } from '@apollo/client';

export const TagsFragmentGql: DocumentNode = gql`
fragment Tags on Taggable {
  tags {
    name
  }
}
`;
